import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import Img from "../ui/Img";
import Button from "../ui/Button";
import "../../styles/components/Navbar.css";
import { ReactComponent as MenuIcon } from "../../assets/svg/hamburger-menu.svg";
import { ReactComponent as CloseIcon } from "../../assets/svg/close-x.svg";
import jem_logo from "../../assets/images/Jesus Empowerment Ministries Logo.png";

const Navbar = () => {
  const { navClassName, handleToggleNavOpen } = useNavbar();
  return (
    <header className="bg-white shadow p-2 relative">
      <div className="wrapper flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Link to="/">
            <Img src={jem_logo} width="45" alt="Jesus Empowerment Ministries" />
          </Link>
          <p className="font-bold hidden md:block leading-4 text-sm">
            Jesus <br />
            Empowerment <br />
            Ministries
          </p>
        </div>
        <nav className="hidden md:block">
          <ul className="flex gap-8">
            <li className="hover:text-sky-blue">
              <NavLink className="block" to="/">
                Home
              </NavLink>
            </li>
            <li className="hover:text-sky-blue">
              <NavLink className="block" to="/contact-us">
                Contact
              </NavLink>
            </li>
            <li className="hover:text-sky-blue">
              <NavLink className="block" to="/gallery">
                Gallery
              </NavLink>
            </li>
            <li className="hover:text-sky-blue">
              <NavLink className="block" to="/ministry">
                Ministry
              </NavLink>
            </li>
          </ul>
        </nav>
        <Button className="tracking-wide hidden md:block">GIVE</Button>
        {/* //?____________MOBILE SIDEBAR__________ */}
        <MenuIcon
          onClick={handleToggleNavOpen}
          className="w-10 cursor-pointer text-sky-blue md:hidden"
        />
        <div
          className={`md:hidden z-10 fixed bg-white left-0 right-0 top-0 bottom-0 ${navClassName}`}
        >
          <div
            onClick={handleToggleNavOpen}
            className="flex items-center justify-end p-3"
          >
            <CloseIcon className="w-10 cursor-pointer" />
          </div>
          <nav className="min-h-[600px] flex flex-col items-center justify-center text-center">
            <ul onClick={handleToggleNavOpen} className="flex flex-col gap-8">
              <li className="hover:text-sky-blue">
                <NavLink className="block" to="/">
                  Home
                </NavLink>
              </li>
              <li className="hover:text-sky-blue">
                <NavLink className="block" to="/contact-us">
                  Contact
                </NavLink>
              </li>
              <li className="hover:text-sky-blue">
                <NavLink className="block" to="/gallery">
                  Gallery
                </NavLink>
              </li>
              <li className="hover:text-sky-blue">
                <NavLink className="block" to="/ministry">
                  Ministry
                </NavLink>
              </li>
            </ul>
            <Button className="tracking-wide mt-8">GIVE</Button>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Navbar;

export const useNavbar = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [navClassName, setNavClassName] = useState("mobile-nav-component");

  const handleToggleNavOpen = () => {
    setIsNavOpen(!isNavOpen);
  };

  useEffect(() => {
    setNavClassName(
      isNavOpen ? "mobile-nav-component-open" : "mobile-nav-component"
    );
  }, [isNavOpen]);

  return { navClassName, handleToggleNavOpen };
};
